import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { OfferSummary } from '../../interfaces/Offer/OfferSummary';
import { OfferCard } from './OfferCard';
import { useThemeColor } from '../../hooks/useThemeColor';
import { useLocalizedText } from '../../hooks/useLocalizedText';

interface OffersDialogProps {
  offers: OfferSummary[];
  title?: string;
  open: boolean;
  onClose: () => void;
}

export const OffersDialog = (props: OffersDialogProps) => {
  const t = useLocalizedText();

  const location = useLocation();

  const { primary } = useThemeColor();

  useEffect(() => {
    props.onClose();
  }, [location.pathname]);

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>{props.title ?? t('offer.offers')}</DialogTitle>

      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {props.offers.map((offer) => (
            <OfferCard key={offer.id} offer={offer} />
          ))}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={props.onClose}
          sx={{
            color: primary,
            textTransform: 'none',
          }}
        >
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
};
